import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { WHEEL_IMG, FRAMEWORK, FrameworkKey } from '../data/site';
interface Hotspot {
  key: FrameworkKey;
  label: string;
  style: React.CSSProperties;
}
// Positioned over the supplied wheel image (percentage based, responsive).
const HOTSPOTS: Hotspot[] = [{
  key: 'inputs',
  label: 'Inputs',
  style: {
    top: '20%',
    left: '38%',
    width: '24%',
    height: '20%'
  }
}, {
  key: 'interpretation',
  label: 'Interpretation',
  style: {
    top: '36%',
    left: '60%',
    width: '24%',
    height: '22%'
  }
}, {
  key: 'decisions',
  label: 'Decisions',
  style: {
    top: '60%',
    left: '52%',
    width: '24%',
    height: '22%'
  }
}, {
  key: 'feedback',
  label: 'Feedback',
  style: {
    top: '60%',
    left: '24%',
    width: '24%',
    height: '22%'
  }
}, {
  key: 'improvements',
  label: 'Improvements',
  style: {
    top: '36%',
    left: '16%',
    width: '24%',
    height: '22%'
  }
}, {
  key: 'operating',
  label: 'Operating Layer',
  style: {
    top: '6%',
    left: '24%',
    width: '52%',
    height: '10%'
  }
}];
export function FrameworkWheel() {
  const [active, setActive] = useState<FrameworkKey | null>(null);
  const activeComp = FRAMEWORK.find(c => c.key === active) || null;
  return <div className="relative mx-auto w-full max-w-[520px]" data-id="element-52">
      <motion.img src={WHEEL_IMG} alt="The Mine Geology Systems framework wheel: Inputs, Interpretation, Decisions, Feedback and Improvements inside an Operating Layer of People, Processes, Standards and Consistency." className="w-full select-none" initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} draggable={false} data-id="element-53" />

      {HOTSPOTS.map(spot => {
      const comp = FRAMEWORK.find(c => c.key === spot.key)!;
      const isActive = active === spot.key;
      return <button key={spot.key} type="button" aria-label={`${spot.label}: ${comp.short}`} className="absolute rounded-2xl transition-all duration-200" style={{
        ...spot.style,
        boxShadow: isActive ? `0 0 0 3px ${comp.color}` : 'none',
        backgroundColor: isActive ? `${comp.color}1f` : 'transparent'
      }} onMouseEnter={() => setActive(spot.key)} onMouseLeave={() => setActive(null)} onFocus={() => setActive(spot.key)} onBlur={() => setActive(null)} data-id="element-54" />;
    })}

      <div className="mt-5 min-h-[78px] rounded-xl border border-charcoal/10 bg-cream/70 p-4" data-id="element-55">
        {activeComp ? <motion.div key={activeComp.key} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-56">
            <div className="flex items-center gap-2" data-id="element-57">
              <span className="h-3 w-3 rounded-sm" style={{
            backgroundColor: activeComp.color
          }} data-id="element-58" />
              <span className="text-sm font-bold text-charcoal" data-id="element-59">
                {activeComp.name}
              </span>
            </div>
            <p className="mt-1.5 text-sm leading-relaxed text-warmgray" data-id="element-60">
              {activeComp.short}
            </p>
          </motion.div> : <p className="text-sm text-warmgray" data-id="element-61">
            Hover or focus a segment of the wheel to explore each part of the
            framework.
          </p>}
      </div>
    </div>;
}